const DATE_FORMAT = 'M/D/YYYY';
/**
 * Validates if a date string is in the correct format and is a valid date
 */
function validateDateFormat(dateString) {
    if (!dateString || dateString.trim() === '') {
        return { isValid: false, error: 'Date is required' };
    }
    // More strict regex validation for M/D/YYYY format
    const dateRegex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    if (!dateRegex.test(dateString)) {
        return {
            isValid: false,
            error: `Invalid date format. Expected format: ${DATE_FORMAT}`
        };
    }
    // Parse the date components
    const parts = dateString.split('/');
    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    // Validate month (1-12)
    if (month < 1 || month > 12) {
        return {
            isValid: false,
            error: `Invalid month. Month must be between 1 and 12`
        };
    }
    // Validate day (1-31, but also check for valid days per month)
    if (day < 1 || day > 31) {
        return {
            isValid: false,
            error: `Invalid day. Day must be between 1 and 31`
        };
    }
    // Check if it's a valid date using Date constructor
    const date = new Date(year, month - 1, day);
    if (Number.isNaN(date.getTime())) {
        return {
            isValid: false,
            error: 'Invalid date'
        };
    }
    // Double-check that the parsed date matches the input (catches cases like 2/30/2024)
    if (date.getMonth() !== month - 1 || date.getDate() !== day || date.getFullYear() !== year) {
        return {
            isValid: false,
            error: 'Invalid date (e.g., February 30th does not exist)'
        };
    }
    return { isValid: true };
}
/**
 * Validates a date range (start and end dates)
 */
export function validateDateRange(startDate, endDate) {
    const errors = [];
    const startValidation = validateDateFormat(startDate);
    if (!startValidation.isValid) {
        errors.push(`Start date: ${startValidation.error || 'Invalid date'}`);
    }
    const endValidation = validateDateFormat(endDate);
    if (!endValidation.isValid) {
        errors.push(`End date: ${endValidation.error || 'Invalid date'}`);
    }
    // If both dates are valid, check if start is before end
    if (startValidation.isValid && endValidation.isValid) {
        const startDateObj = new Date(startDate);
        const endDateObj = new Date(endDate);
        if (startDateObj > endDateObj) {
            errors.push('Start date must be before or equal to end date');
        }
    }
    return {
        isValid: errors.length === 0,
        errors
    };
}
/**
 * Strict validation that rejects any invalid date immediately
 * This function is used to prevent invalid dates from being accepted
 */
export function strictDateValidation(dateString) {
    if (!dateString || dateString.trim() === '') {
        return { isValid: false, error: 'Date cannot be empty' };
    }
    return validateDateFormat(dateString);
}
